// extracted by mini-css-extract-plugin
export default {"card":"card_card__mZ32r","cardImgView":"card_cardImgView__AYIi2","img":"card_img__EpkMZ","cardTitleView":"card_cardTitleView__QA6Q0","cardButtonView":"card_cardButtonView__RQhxz"};